import React from "react";
import styled from "styled-components";
import Slick from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BlogCard from "./BlogCard";
import Breakpoints from "./styles/Breakpoints";

const Wrapper = styled.div`
  padding: 0 32px 64px;

  margin-bottom: 16px;

  .slick-slide {
    opacity: 0.66;

    transition: opacity 0.5s ease;
  }

  .slick-current {
    opacity: 1;
  }

  .gatsby-image-wrapper {
    max-height: 320px;
  }

  @media ${Breakpoints.tablet} {
    padding-bottom: 0;

    width: 90%;
    margin: 0 auto 16px;

    .gatsby-image-wrapper {
      max-height: unset;
    }

    .slick-slider.slick-initialized {
      display: flex;
    }
  }
`;

const Button = styled.button`
  border: 0;
  background: 0;
  appearance: none;

  position: absolute;

  left: ${(props) => props.right && "52px"};
  bottom: -64px;

  outline: none;

  @media ${Breakpoints.tablet} {
    position: static;
    transform: scale(1.25);

    margin: 0 10px;
  }
`;

function Arrow({ right, className, style, onClick }) {
  if (right) {
    return (
      <Button right={right} onClick={onClick}>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="19.5" stroke="#F0EFED" />
          <path
            d="M18 26L24 20L18 14"
            stroke="#F0EFED"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    );
  }

  return (
    <Button onClick={onClick}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="19.5" stroke="#F0EFED" />
        <path
          d="M22 26L16 20L22 14"
          stroke="#F0EFED"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );
}

const SLICK_OPTIONS = {
  infinite: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: false,
  nextArrow: <Arrow right />,
  prevArrow: <Arrow />,
};

export default function BlogCarousel({ posts = [] }) {
  return (
    <Wrapper>
      <Slick {...SLICK_OPTIONS}>
        {posts.map((p) => (
          <BlogCard post={p} />
        ))}
      </Slick>
    </Wrapper>
  );
}
